import { render, staticRenderFns } from "./EmployeeGroups.vue?vue&type=template&id=bca408da&"
import script from "./EmployeeGroups.vue?vue&type=script&lang=js&"
export * from "./EmployeeGroups.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeGroups.vue?vue&type=style&index=0&id=bca408da&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports